import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Header, 
  Breadcrumb, 
  Icon,Button,Loader, 
  Note,
  TableWrapper,
  ImgLoader,
  Input,
  TextArea,
  Modal,HideColumn } from '../components'
import { Link } from 'react-router-dom'
import axios from 'axios'
import get from 'lodash/get'
import map from 'lodash/map'
import filter from 'lodash/filter'
 import find from 'lodash/find'
import { toast } from 'react-toastify'
import moment from 'moment'
import Select from "react-select";
import { groupBy, isEmpty, sortBy, union } from 'lodash'
// import uuidv4 from "uuid";
import { Formik, Field } from "formik";


const Container = styled.div`
  width: 100%;
  padding: 50px 10px 15px 10px; 
  max-width: 800px;
  margin: auto;
`
const AutoFindArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: rgb(0 138 61 / 10%);
  border-radius: 4px;
  & > div {
    width: calc(100% - 100px);
    display: flex;
    align-items: center;
    padding: 0 5px;
    & label{
      font-size: 12px;
      padding-right: 10px;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0px;
  & > div {
    width: ${(props) => (props.width ? props.width : "100%")};
    margin-bottom: 10px;
    display: flex;
    & > div{
      width: 100%;
    }
  }
  & > div:nth-child(2), & > div:nth-child(3){
    & > div{
      width: 100%;
    }
  }
`;

const SearchWrapper = styled.div`
display: flex;
& input{
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-left: 20px;
  padding: 0 10px;
  &:focus {
    box-shadow:none;
    outline:none;
  }
}
`

const InputWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0px;
  & > div:nth-child(1){
    width: 50%;
    padding-right:5px;  
  } 
  & > div:nth-child(2){
    width:50%;
    padding-left:5px
  }
  & > div > label{
    margin:0px;
    padding-bottom:5px;
    display:block;
  }
`;


const ButtonWrapper = styled.div`
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Table = styled.table`
  width: 100%;
  background: #fff;
  font-size: 12px;
  border-collapse: collapse;
  & th, td {
   padding: 8px 5px;
   border: 1px solid #e4e4e4;
   &:first-child{
     text-align: center;
   }
}
& thead tr{
  background: #020266 !important;
  color: #fff !important;
  th{
    padding: 10px 5px !important;
  }
  & th:first-child{
    width: 30px;
  }
}
& tr:nth-child(odd){
  background:#fafafa;
  cursor: pointer;
}
& tr:nth-child(even){
  background:#fff;
  cursor: pointer;
}
` 
const ProjectView = styled.div`
  width:100%;
  padding:10px;
  overflow: scroll;
  height: 100%;
  padding-bottom: 50px;
`
const ProjectCode= styled.div`
  display: flex;
  & > div{
    & > p{
      margin: 0;
      color: #8e8e8e;
      padding-top: 5px;
      font-size:11px;
    }
  }
`
const Gallery = styled.div`
  position:relative;
  & > div{
    padding-bottom: 10px;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    & img{
      width: 100%;
    }
  & p{
    position: absolute;
    z-index: 99;
    bottom: 10px;
    width: 100%;
    margin: 0;
    color: #fff;
    padding: 6px;
  }
}

`
const Button1 = styled.button`
  padding: 10px 25px;
  background: #020266;
  border: 1px solid #020266;
  border-radius: 4px;
  color: #fff;
  margin: 0 5px;
`;


class NearestBeneficiaries extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      stateList:[],
      cityData:{},
      cityList:[],
      projectsList:[],
      beneficiariesList:[],
      state:'',
      city:'',
      projectData:{},
      beneficiariesData:{},
      searchType:'projects',
      rediusOfKm:50,
      latitude:'',
      longitude:'',
      ISSRandAHPImg:[],
      benProjectDetails:{},
      beneficiariesImages:[],
      progress:{},
      searchBen:'',
      permission:{},
      ComponentHideShowMoS:["PMAY-U"],
      loaderMsg: 'Loading...'
    };
    // this.getLocation = this.getLocation.bind(this);
}
  componentDidMount = async () => {
     // state api calls
     const { data } = await axios.get("/states");
     // const { data: components } = await axios.get("/component");
     const { data: permission } = await axios.get(`/dashboard/permission`)
//console.log('navigator.geolocation---->>>>>>',navigator.geolocation)
    //  checked location
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition((position)=> {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude
  //       console.log('ajitlatitude',latitude,'longitude',longitude)
        this.setState({latitude,longitude})
      })
    navigator.permissions && navigator.permissions.query({name: 'geolocation'})
    .then(function(PermissionStatus) {
        if (PermissionStatus.state === 'denied') {
            navigator.permissions.query({name:'geolocation', userVisibleOnly:true})
            alert('Need to location permission allow.')  //allowed
        } 
    })
  }else{
    alert("Geolocation is not supported on your Browser/OS.");
  }


     this.setState({
      stateList: map(data, (obj) => ({
         label: obj.statename,
         value: obj.statecode,
       })),
       permission,
       // componentList: map(components, (obj) => ({ label: obj, value: obj })),
       isLoading: false,
     });
  }

  getCity = async (e) => {
    const {searchType,latitude,longitude,rediusOfKm,ComponentHideShowMoS}=this.state
    this.setState({isLoading:true,city:'',state:e, loaderMsg:'City Fetching... '})
      console.log('e====city==>>', e)
     console.log('searchType====city==>>', searchType)
    console.log('ComponentHideShowMoS=====>>', ComponentHideShowMoS)
    console.log('ComponentHideShowMoS=====>>', ComponentHideShowMoS.length)
    const { data: city } = await axios.get(`/city/state/${e.value}`);
    console.log('city------->>>>>>>',city);
    
    const { data: projectsList } = searchType ==='projects' ? await axios.get(`/visitor/geo-location/state/${e.value}/${latitude}/${longitude}/${rediusOfKm}`):[]
    console.log('visitor------->>>>>>>',`/visitor/geo-location/state/${e.value}/${latitude}/${longitude}/${rediusOfKm}`);
console.log('projectsList------->>>>>>>',projectsList);
const data2={
  visitor:'yes',
  latitudefrom:latitude,
  longitudefrom:longitude,
  tolatitude:21,
  tolongitude:21,
  benf_code:e.value,
}

await axios.post(`/visitor/logDetails/`,data2)

    this.setState({
      project: "",
      cityList: map(city, (obj) => ({
        value: obj.CityCode,
        label: obj.CityName,
        ...obj
      })),
      isLoading: false,
      projectsList
    });
 }

 getProjects = async (e) => {
    console.log('e.value=====>>', e)
  const {searchType,latitude,longitude,rediusOfKm}=this.state

  this.setState({isLoading:true,city:e,projectsList:[], beneficiariesList:[], loaderMsg:'Project Fetching...'})

  if(searchType ==='projects'){
    const { data: projectsList } = await axios.get(`/visitor/geo-location/city/${e.value}/${latitude}/${longitude}/${rediusOfKm}`)
    this.setState({projectsList,isLoading:false})
  }else{

    const { data: beneficiary } = await axios.get(`/beneficiary/mis_beneficiaries_cityWise/${e.value}`);
    //  const { data: beneficiary2 } = [] //await axios.get(`/beneficiary/PMAYU2_beneficiaries_cityWise/${e.value}`);
    const { data: beneficiary2 } = await axios.get(`/beneficiary/mis_beneficiaries_cityWise2/${e.value}`);
    console.log('beneficiary---->>>>>',beneficiary);
     console.log('beneficiary2---->>>>>',beneficiary2);
     console.log('beneficiary2---->>>>>',`/beneficiary/mis_beneficiaries_cityWise2/${e.value}`);

    const checkDistanceBenificiary = map(beneficiary, bn=>{
      const km =this.getDistanceFromLatLonInKm(latitude,longitude,Number(bn.lat),Number(bn.lon)) 

      return({...bn, km, annexureId:bn.annexure_d,scheme_uniq_id:3})
    })

      const checkDistanceBenificiary2 = map(beneficiary2, bn=>{
      const km =this.getDistanceFromLatLonInKm(latitude,longitude,Number(bn.lat),Number(bn.lon)) 

      return({...bn, km, annexureId:bn.annexure_d,scheme_uniq_id:4})
    })

    // this.setState({isLoading:false,beneficiariesList: union(this.state.beneficiariesList,checkDistanceBenificiary,checkDistanceBenificiary2)}) 

this.setState(prevState => ({
  isLoading: false,
  beneficiariesList: union(
    prevState.beneficiariesList,
    checkDistanceBenificiary,
    checkDistanceBenificiary2
  )
}));


  }
}



  getLocation=()=>{
    let that = this
    console.log('that------->>>',that);
    console.log('this------->>>',this);

    if (navigator.geolocation) {
      this.setState({isLoading: true, loaderMsg:'Location base data fetching...'})
      // check location permissions
      navigator.permissions && navigator.permissions.query({name: 'geolocation'})
        .then(function(PermissionStatus) {
          console.log('PermissionStatus---->>>>>>>',PermissionStatus);
            if (PermissionStatus.state === 'denied') {
                // navigator.permissions.query({name:'geolocation', userVisibleOnly:true})
                that.setState({isLoading: false, loaderMsg:''})
                alert('Need to location permission allow.')  
                return
            } 
        })

      // console.log('enable')
      navigator.geolocation.getCurrentPosition(async(position)=> {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude

        // const {data}= await axios.get(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,{ withCredentials: true })
        // fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=28.642881&longitude=77.338105&localityLanguage=en`, {
          fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`, {
          method: 'GET',
          redirect: 'follow'
        }).then(response => response.json())
        .then(async(data) =>{
    
          const locality = get(data,'locality')
          //console.log('district--->',district)
    
          const district =  get(find(get(data,'localityInfo.administrative'),fnd=> fnd.order === 11),'name').replace(' district','')
      
          const { data: cityData } =  get(data,'city') === 'Delhi' ? await axios.get(`/visitor/search-city/${locality}/${district}`) : await axios.get(`/visitor/search-city/${locality}/${district}`)
        

          const data2={
            visitor:'yes',
            latitudefrom:latitude,
            longitudefrom:longitude,
            tolatitude:21,
            tolongitude:21,
            benf_code:get(cityData,'0.StateCode'),
          }
          
          
          await axios.post(`/visitor/logDetails/`,data2)
          // Find Projects
          if(this.state.searchType === 'projects'){
            const { data: projectsList } = await axios.get(`/visitor/geo-location/${latitude}/${longitude}/${this.state.rediusOfKm}`)
            const state= get(cityData,'0.StateCode') ? find(this.state.stateList, fnd=> fnd.value === get(cityData,'0.StateCode') ) : ''
            that.setState({state,projectsList,latitude,longitude, isLoading:false, city:{value:get(cityData,'0.CityCode'), label:get(cityData,'0.CityName')}, cityList:map(cityData, ct=>({...ct, label:ct.CityName, value:ct.CityCode})),cityData})
          }else{
          // Find  Beneficiaries
          const state= get(cityData,'0.StateCode') ? find(this.state.stateList, fnd=> fnd.value === get(cityData,'0.StateCode') ) : ''
         console.log('state---->>>>',state);
          that.setState({
            state,
            projectsList:[],
            latitude,
            longitude,
            isLoading:false,
            city:{value:get(cityData,'0.CityCode'), label:get(cityData,'0.CityName')},
            cityList:map(cityData, ct=>({...ct, label:ct.CityName, value:ct.CityCode})),
            cityData
          },()=>{
            this.getProjects({...get(cityData,'0'),value:get(cityData,'0.CityCode'), label:get(cityData,'0.CityName')})
          })
        }

         
        })

      
      });
    } else { 
      alert("Geolocation is not supported on your browser!");
      // that.setState({ loaderMsg:"Geolocation is not supported by this browser."})
    }

  }


   getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2-lat1);  // this.deg2rad below
    var dLon = this.deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    return d;
  }
  
   deg2rad(deg) {
    return deg * (Math.PI/180)
  }

  render() {
    const {loaderMsg,ComponentHideShowMoS,beneficiariesData,stateList,cityList,projectsList,state,city,rediusOfKm,projectData,benProjectDetails,beneficiariesImages, searchType,longitude,latitude,beneficiariesList,permission  } = this.state
   const projectsList2= ComponentHideShowMoS.length===2 ? projectsList : ComponentHideShowMoS.indexOf('PMAY-U')!==-1 ? filter(projectsList,f=>f.scheme_uniq_id !== 4) : ComponentHideShowMoS.indexOf('PMAY(U)20')!==-1 ? filter(projectsList,f=>f.scheme_uniq_id === 4) : []
   

   const beneficiariesList2= ComponentHideShowMoS.length===2 ? beneficiariesList : ComponentHideShowMoS.indexOf('PMAY-U')!==-1 ? filter(beneficiariesList,f=>f.scheme_uniq_id !== 4) : ComponentHideShowMoS.indexOf('PMAY(U)20')!==-1 ? filter(beneficiariesList,f=>f.scheme_uniq_id === 4) : []



  //  filter(projectsList,f=>ComponentHideShowMoS   .indexOf(f.value)!==-1     searchType === 'projects' ?  : projectsList
  
    const benData = sortBy(groupBy(this.state.searchBen ? filter(beneficiariesList2,f=>(f.ben_name || '').toLowerCase().indexOf(this.state.searchBen)!==-1 || (f.ben_father || '').toLowerCase().indexOf(this.state.searchBen)!==-1 || (f.construction_stage || '').toLowerCase().indexOf(this.state.searchBen)!==-1 || (f.benf_code || '').toLowerCase().indexOf(this.state.searchBen)!==-1):beneficiariesList2, 'ben_name'), obj=> get(obj,'0.km'))

    const filteredState= get(permission,'data.type')==='admin' ? stateList :  get(permission,'data.type')!=='admin' && isEmpty(get(permission,'data.allowState')) ? stateList : filter(stateList,f=>get(permission,'data.allowState').indexOf(f.value)!==-1)

    // console.log('benData===?>>', this.state.progressData)
    // console.log('projectData===?>>', {projectData,beneficiariesData,benProjectDetails})
     console.log('ComponentHideShowMoS-------->',ComponentHideShowMoS)
    return (
      <React.Fragment>
        {this.state.isLoading && <Loader loaderMsg={loaderMsg} />}
        <Header />
        <Container>
          <Breadcrumb>
            <Link to='/'>Home</Link>
            <Icon icon='rightArrow' width={10} height={10} />
          Nearest Project & Beneficiaries
      </Breadcrumb>



                  <HideColumn
                    background="#ebf9f5"
                    fontSize={15}
                    // columnList={[{ title: "Progress of JnNURM", key: "JnNURMProgress" }, { title: "PMAY(U) 2.0", key: "PMAY(U)20" },{ title: "PMAY-U", key: "PMAY-U" },{ title: "PMAY-U 2.0 & PMAY-U", key: "PMAYUBOTH" }]}
                    columnList={[{ title: "PMAY-U", key: "PMAY-U" },{ title: "PMAY(U) 2.0", key: "PMAY(U)20" }]}
                    name="NotDefault"
                    hideColumn={this.state.ComponentHideShowMoS}
                    getHideColumn={(ComponentHideShowMoS) => this.setState({ ComponentHideShowMoS })}
                  />
            

      <Wrapper style={{paddingBottom:0}}>
        <div>
          <div onClick={()=> this.setState({searchType:'projects', projectsList:[], beneficiariesList:[], city:''})}><input type='radio' name='searchType' defaultChecked={searchType=== 'projects' ? true :false} id='projects'/> <label htmlFor='projects'>Find Projects</label></div>
          <div onClick={()=> this.setState({searchType:'beneficiaries', projectsList:[], beneficiariesList:[], city:''})}><input type='radio' name='searchType' defaultChecked={searchType=== 'beneficiaries' ? true :false} id='beneficiaries'/> <label htmlFor='beneficiaries'>Find Beneficiaries</label></div>
        </div>
      </Wrapper>
      <AutoFindArea>
        <div>
          <label>{rediusOfKm} KM</label> <input value={rediusOfKm} onChange={(e)=> this.setState({rediusOfKm: e.target.value})} name='rediusOfKm' type='range' id='rediusOfKm'/>
        </div>
        {/* <Button onClick={this.getLocation}><Icon icon='map' color='#ed143d'/> Auto Find</Button> */}
      </AutoFindArea>
         
        <Wrapper>
            <div style={{width:'100%'}}>
              <Select
                options={filteredState}
                placeholder={"Select State"}
                value={state}
              // isDisabled={'get(match, "params.id")' ? true : false}
              onChange={this.getCity }
              />
            </div>
            <div style={{width:'100%'}}>
            <Select
                options={cityList}
                placeholder={"Select City"}
                value={city}
              // isDisabled={get(match, "params.id") ? true : false}
              onChange={this.getProjects}
              />
              </div>
            {/* <div style={{width:'100%'}}>
              <Select
                options={projectsList}
                placeholder={"Select Project"}
                value={project}
              // isDisabled={get(match, "params.id") ? true : false}
              // onChange={ }
              />
            </div> */}

          </Wrapper>
            <SearchWrapper>
            <h4 style={{marginBottom:10,marginTop:5, color:'red'}}>{searchType==='projects' ? 'Project List' : 'Beneficiaries'}</h4>
            {searchType==='projects' ?'':
            <input  placeholder='Search...' onChange={(e)=> this.setState({searchBen:get(e,'target.value','').toLowerCase()})}/>
          }
            </SearchWrapper>
            {/* {map(Object.keys(currentLoc), ob=>{
              // console.log('ck===>',ob)
              return(
                <p><b>{ob} : </b>{get(currentLoc,`${ob}`)}</p>
                )
            })} */}

          {/* <h4 style={{marginBottom:0, color:'red'}}>Current data</h4>
            {map(Object.keys(cityData), ob=>{
              // console.log('ck===>',ob)
              return(
                <p><b>{ob} : </b>{get(cityData,`${ob}`)}</p>
                )
            })} */}


            <Table cellspacing='0' border="1">
              <thead>
                {searchType === 'projects' ? <tr>
                  <th>Sr.</th>
                  {/* <th>CSMC Date/No.</th> */}
                  <th>City</th>
                  <th>Component</th>
                  <th>Houses</th>
                  <th>Distance</th>
                  </tr>
                  :
                  <tr>
                    <th>Sr.</th>
                    <th>Name</th>
                    <th>City</th>
                    <th>Last<br />UPD</th>
                    <th>Distance</th>
                  </tr>
                  }
              </thead>
              <tbody>
            {/* {this.state.isLoading && <Loader/>} */}
            {map(projectsList2, (item, idx)=> {
           console.log(item,'----searchType---->>>>>>>>>>',searchType)
           
              const isGeoLocation = get(item,'longitude') && get(item,'latitude') && longitude && latitude ? true : false
              return(
                <tr key={idx} onClick={async()=> {
                  this.setState({isLoading:true})
                  const { data: ISSRandAHPImg } = await axios.get(`/visitor/ahp-issr-image/${item.ProjectCode}`)
                  const { data: progress } = await axios.get(`/visitor/physical-progress/${item.ProjectCode}`);
                  const progressData = progress[0] ? progress[0] : {}
                  this.setState({ISSRandAHPImg,isLoading:false,projectData: {...item, ...progressData}})
                }}>
                <td> {idx+1}. </td>
                <td> {get(item,'CityName') ? get(item,'CityName') :'-'} </td>
               
                {/* <td> {moment(get(item,'CSMCDate')).format('DD-MMM-YYYY')} /  <strong style={{color:'red'}}>{get(item,'CSMCNo')}</strong> </td> */}
                <td> {get(item,'Component')} </td>
                <td style={{textAlign:'right'}}> { ( Number(item.HousesSanctionedNew || 0) + Number(item.HousesSanctionedEnahncement || 0)) ? ( Number(item.HousesSanctionedNew || 0) + Number(item.HousesSanctionedEnahncement || 0)).toLocaleString("en-in"):'-'} </td>
                <td style={{textAlign:'right'}}>
                  {get(item,'km') ? get(item,'km').toFixed() :'-'} KM  {isGeoLocation ? <Icon height={12} icon='map' color='#ed143d'/> :''}
                  {get(item,'geoTagImage') ? <Icon height={12} width={16} icon='image' color='#008b8b'/> :''}
                </td>
              </tr>
              )
            })}
          {/* For Beneficiaries */}
            {map(benData, (item, idx)=> {
               console.log('idx', idx, typeof idx)
                console.log('item', item, typeof item)
                
                // console.log('scheme_uniq_id--->>>>',Number(get(item,'0.scheme_uniq_id')))
            
const date0 = get(item,'0.LastDate')? get(item,'0.LastDate').split('/')[0] : ''
const date1 = get(item,'0.LastDate')? get(item,'0.LastDate').split('/')[1] : ''
const date2 = get(item,'0.LastDate')? get(item,'0.LastDate').split('/')[2] : ''

const date = date2 ? `${date1}-${date2}` :"-"

              if(idx===0){
                 //console.log('items---->>', item)
              }
         
              const isGeoLocation = get(item,'0.lon') && get(item,'0.lat') && longitude && latitude ? true : false
              return(
                <tr style={{background:get(item,'0.construction_stage')==="Completed" ? 'green' : '' ,color:get(item,'0.construction_stage')==="Completed" ? 'white' : ''}} key={idx} onClick={async()=>{
                   this.setState({beneficiariesData: item})
                   const { data: benProjectDetails } = await axios.get(`/visitor/project-for-beneficiary/${get(item,'0.annexureId')}`)
                   const datatoSend={
                      state_code:get(item,'0.state_code'),
                    benf_code:get(item,'0.benf_code')
                  }
                  
                   const { data: benfimage } = Number(get(item,'0.scheme_uniq_id'))===4 ? await axios.post(`/visitor/Imagedetails2/`,datatoSend) :await axios.post(`/visitor/Imagedetails/`,datatoSend);

                   this.setState({beneficiariesImages:benfimage,benProjectDetails:benProjectDetails.length? benProjectDetails[0]:{}})
                }}>
                <td> {idx+1}. </td>
                <td> {get(item,'0.ben_name') ? get(item,'0.ben_name') :'-'} </td>
                <td> {get(city,'label') ? get(city,'label') :'-'} </td>
                <td> {date ? date :'-'} </td>
                <td style={{textAlign:'right'}}>
                  {get(item,'0.km') ? get(item,'0.km').toFixed() :'-'} KM  {isGeoLocation ? <Icon height={12} icon='map' color='#ed143d'/> :''}
                  {get(item,'0.photo1') ? <Icon height={12} width={16} icon='image' color='#008b8b'/> :''}
                </td>
              </tr>
              )
            })}
            </tbody>
          </Table>
        </Container>

        {!isEmpty(projectData) ?
        <Modal onClickIcon={()=> this.setState({projectData:{}, ISSRandAHPImg:[]})}>
          <ProjectView>
            <ProjectCode>
              <div>
                Project Code
                <p>{get(projectData,'ProjectCode') ? get(projectData,'ProjectCode') : ''}</p>
              </div>
              <div style={{display: 'flex',paddingLeft:10, justifyContent:'flex-end', width:'100%'}}>

              <Button onClick={()=>{
                this.setState({progress:projectData})
              }}><Icon icon='edit' color='blue'/> Edit</Button>
              
              <Button style={{marginLeft:10}} onClick={async()=>{
                this.setState({isLoading:true,loaderMsg:'Please wait..'})
                const { data: project } = await axios.get(`/project-details/${get(projectData,"StateCode")}/${get(projectData,"CityCode")}`);
                const { data: city } = await axios.get(`/city/state/${get(projectData,"StateCode")}`);
                  const  citis = map(city, (obj) => ({
                  value: obj.CityCode,
                  label: obj.CityName,
                }))

               const projectList= map(project, (obj) => ({
                  ...obj,
                  value: obj.ProjectCode,
                  label: `CSMC Date:${moment(obj.CSMCDate).format(
                    "DD-MMM-YYYY"
                  )}, CSMC No:${obj.CSMCNo}, Houses: ${(
                    Number(obj.HousesSanctionedNew) +
                    Number(obj.HousesSanctionedEnahncement)
                  ).toLocaleString("en-in")}`,
                }))

                // console.log('project----->>', project)

                if (!isEmpty(project)) {
                  localStorage.setItem(
                    "draft",
                    JSON.stringify({
                      cityList:citis,
                      city:find(citis,fnd=> fnd.value === get(projectData,'CityCode')),
                      state:find(stateList,fnd=> fnd.value === get(projectData,'StateCode')),
                      project:{...projectData, 
                        value: projectData.ProjectCode,
                        label: `CSMC Date:${moment(projectData.CSMCDate).format(
                          "DD-MMM-YYYY"
                        )}, CSMC No:${projectData.CSMCNo}, Houses: ${(
                          Number(projectData.HousesSanctionedNew) +
                          Number(projectData.HousesSanctionedEnahncement)
                        ).toLocaleString("en-in")}`, },
                      projectList,
                      createdAt: moment().format("DD-MMM-YYYY"),
                    })
                  );
                
                  this.props.history.push("/form");
                }else{
                  toast("Data not found !", {
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
                }
                this.setState({isLoading:false,loaderMsg:''})

              }}><Icon icon='form' color='orange'/> Inspection</Button>
              
              <Button style={{marginLeft:10}} onClick={()=>{
                window.open(`https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${get(projectData,'latitude')},${get(projectData,'longitude')}`)
              }}><Icon icon='map' color='#ed143d'/> Go</Button>

              </div>
            </ProjectCode>

                {/* Note */}
                <Note style={{paddingTop:15}}>
                  <span>Note:</span>
                  {get(projectData,'ProjectTitle') ? get(projectData,'ProjectTitle') : ''}
                </Note>
              {/* {console.log('projectData---->>', projectData)} */}
                <TableWrapper>
                    <div>
                      {" "}
                      Financial Progress <span>(in Cr.)</span>
                    </div>
                    <table border="1px" border-colapse={"colapse"}>
                      <thead>
                        <tr>
                          <td>Invesment</td>
                          <td>CA Approved</td>
                          <td>CA Released</td>
                          <td>UC Pending</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {Number(
                              get(
                                projectData,
                                "ProjectCost",
                                0
                              )
                            )
                              ? Number(
                                  get(
                                    projectData,
                                    "ProjectCost",
                                    0
                                  )
                                ).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(
                              get(
                                projectData,
                                "CentralAssistApproved",
                                0
                              )
                            )
                              ? Number(
                                  get(
                                    projectData,
                                    "CentralAssistApproved",
                                    0
                                  )
                                ).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(get(projectData,"installment1",0))+Number(get(projectData,"installment2",0))+Number(get(projectData,"installment3",0))+Number(get(projectData,"installment4",0))
                              ? Number(Number(get(projectData,"installment1",0))+Number(get(projectData,"installment2",0))+Number(get(projectData,"installment3",0))+Number(get(projectData,"installment4",0))).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(Number(get(projectData,"installment1",0))+Number(get(projectData,"installment2",0))+Number(get(projectData,"installment3",0))+Number(get(projectData,"installment4",0))) -
                            Number(Number(get(projectData,"uc1",0))+Number(get(projectData,"uc2",0))+Number(get(projectData,"uc3",0))+Number(get(projectData,"uc4",0)))
                              ? (Number(Number(get(projectData,"installment1",0))+Number(get(projectData,"installment2",0))+Number(get(projectData,"installment3",0))+Number(get(projectData,"installment4",0))) -
                              Number(Number(get(projectData,"uc1",0))+Number(get(projectData,"uc2",0))+Number(get(projectData,"uc3",0))+Number(get(projectData,"uc4",0)))) > 0 ? (Number(Number(get(projectData,"installment1",0))+Number(get(projectData,"installment2",0))+Number(get(projectData,"installment3",0))+Number(get(projectData,"installment4",0))) -
                              Number(Number(get(projectData,"uc1",0))+Number(get(projectData,"uc2",0))+Number(get(projectData,"uc3",0))+Number(get(projectData,"uc4",0)))).toFixed(2): '-'
                            : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </TableWrapper>

                  <TableWrapper>
                        <div>
                          {" "}
                          Physical Progress <span>(Nos)</span>
                        </div>
                        <table border="1px" border-colapse={"colapse"}>
                          <thead>
                            <tr>
                              <td>Houses</td>
                              <td>Grounded</td>
                              <td>Completed</td>
                              <td>Occupied</td>
                              <td>Plinth</td>
                              <td>Lintel</td>
                              <td>Roof</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {get(
                                  projectData,
                                  "HousesSanctionedEnahncement",
                                  0
                                )+get(
                                  projectData,
                                  "HousesSanctionedNew",
                                  "-"
                                )
                                  ? get(
                                      projectData,
                                      "HousesSanctionedEnahncement",
                                      "-"
                                    )+get(
                                      projectData,
                                      "HousesSanctionedNew",
                                      "-"
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "totalWorkOrders",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "totalWorkOrders",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "completed",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "completed",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "occupied",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "occupied",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "plinth",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "plinth",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "lintel",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "lintel",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  projectData,
                                  "roof",
                                  0
                                )
                                  ? get(
                                      projectData,
                                      "roof",
                                      0
                                    )
                                  : "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </TableWrapper>

                      <Gallery>
                        {
                          map(this.state.ISSRandAHPImg, (arr,i)=>{
                            // console.log('arr------>>',arr)
                              return(
                                <React.Fragment key={i}>
                                <div>
                                  {/* <img src={arr.photo1} alt=''/> */}
                                  <ImgLoader src={arr.photo1} className={'photo1'+i} alt="..."/>
                                  <p style={{background:'orange'}}>{arr.Construction_Stage_Geo_tagged}, <strong>{arr.Construction_Geo_tagged_Date}</strong></p>
                                </div>
                                <div>
                                  {/* <img src={arr.photo2} alt=''/> */}
                                  <ImgLoader src={arr.photo2} className={'photo2'+i} alt="..."/>
                                  <p style={{background:'orange'}}>{arr.Construction_Stage_Geo_tagged}, <strong>{arr.Construction_Geo_tagged_Date}</strong></p>
                                </div>
                                </React.Fragment>
                              )
                          })
                        }
                        {isEmpty(this.state.ISSRandAHPImg) ? <p 
                          style={{
                                height: 100,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 600}}
                            >Image not available</p> :''}
                      </Gallery>

          </ProjectView>
        </Modal>:''}

        {/* Beneficiaries Modal */}

        {!isEmpty(beneficiariesData) ?
        <Modal onClickIcon={()=> this.setState({beneficiariesData:{},benProjectDetails:{}})}>
          <ProjectView>
            <ProjectCode>
              <div>
              {get(beneficiariesData,'0.ben_name') ? get(beneficiariesData,'0.ben_name') : ''}
                <p>{get(beneficiariesData,'0.benf_code') ? get(beneficiariesData,'0.benf_code') : ''}</p>
              </div>

              <Button style={{marginLeft:10}} onClick={async()=>{
                this.setState({isLoading:true,loaderMsg:'Please wait..'})
                const { data: project } = await axios.get(`/project-details/${get(benProjectDetails,"StateCode")}/${get(benProjectDetails,"CityCode")}`);
                const { data: city } = await axios.get(`/city/state/${get(benProjectDetails,"StateCode")}`);
                  const  citis = map(city, (obj) => ({
                  value: obj.CityCode,
                  label: obj.CityName,
                }))

               const projectList= map(project, (obj) => ({
                  ...obj,
                  value: obj.ProjectCode,
                  label: `CSMC Date:${moment(obj.CSMCDate).format(
                    "DD-MMM-YYYY"
                  )}, CSMC No:${obj.CSMCNo}, Houses: ${(
                    Number(obj.HousesSanctionedNew) +
                    Number(obj.HousesSanctionedEnahncement)
                  ).toLocaleString("en-in")}`,
                }))

                // console.log('project----->>', project)

                if (!isEmpty(project)) {
                  localStorage.setItem(
                    "draft",
                    JSON.stringify({
                      cityList:citis,
                      city:find(citis,fnd=> fnd.value === get(benProjectDetails,'CityCode')),
                      state:find(stateList,fnd=> fnd.value === get(benProjectDetails,'StateCode')),
                      project:{...benProjectDetails, 
                        beneficiaryCode: get(beneficiariesData,'0.benf_code'),
                        value: benProjectDetails.ProjectCode,
                        label: `CSMC Date:${moment(benProjectDetails.CSMCDate).format(
                          "DD-MMM-YYYY"
                        )}, CSMC No:${benProjectDetails.CSMCNo}, Houses: ${(
                          Number(benProjectDetails.HousesSanctionedNew) +
                          Number(benProjectDetails.HousesSanctionedEnahncement)
                        ).toLocaleString("en-in")}`, },
                      projectList,
                      createdAt: moment().format("DD-MMM-YYYY"),
                    })
                  );
                
                  this.props.history.push("/form");
                }else{
                  toast("Data not found !", {
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
                }
                this.setState({isLoading:false,loaderMsg:''})

              }}><Icon icon='form' color='orange'/> Inspection</Button>

              <Button onClick={async()=>{
console.log('beneficiariesData---->>>>>>>',beneficiariesData);
                      const data2={
                        visitor:'yes',
                        latitudefrom:latitude,
                        longitudefrom:longitude,
                        tolatitude:get(beneficiariesData,'0.lat'),
                        tolongitude:get(beneficiariesData,'0.lon'),
                        benf_code:get(beneficiariesData,'0.benf_code'),
                      }
          

             await axios.post(`/visitor/logDetails/`,data2)

window.open(`https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${get(beneficiariesData,'0.lat')},${get(beneficiariesData,'0.lon')}`)
             
             
             
             }}><Icon icon='map' color='#ed143d'/> Direction</Button>
            </ProjectCode>

            <TableWrapper>
                    <div>Beneficiary Details</div>
                    <table border="1px" border-colapse={"colapse"}>
                      <tbody>
                        <tr>
                          <th style={{fontSize:12}}>Name</th>
                          <td>{get(beneficiariesData,'0.ben_name') ? get(beneficiariesData,'0.ben_name') : '-'}</td>
                        </tr>
                        <tr>
                          <th style={{fontSize:12}}>Father</th>
                          <td>{get(beneficiariesData,'0.ben_father') ? get(beneficiariesData,'0.ben_father') : '-'}</td>
                        </tr>
                        <tr>
                          <th style={{fontSize:12}}>Address</th>
                          <td>{get(beneficiariesData,'0.address') ? get(beneficiariesData,'0.address') : '-'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </TableWrapper>

                {/* Note */}
                <Note style={{paddingTop:15}}>
                  <span>Note:</span>
                  {get(benProjectDetails,'ProjectTitle') ? get(benProjectDetails,'ProjectTitle') : ''}
                </Note>

                 <TableWrapper>
                    <div>
                      {" "}
                      Financial Progress <span>(in Cr.)</span>
                    </div>
                    <table border="1px" border-colapse={"colapse"}>
                      <thead>
                        <tr>
                          <td>Invesment</td>
                          <td>CA Approved</td>
                          <td>CA Released</td>
                          <td>UC Pending</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {Number(
                              get(
                                benProjectDetails,
                                "ProjectCost",
                                0
                              )
                            )
                              ? Number(
                                  get(
                                    benProjectDetails,
                                    "ProjectCost",
                                    0
                                  )
                                ).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(
                              get(
                                benProjectDetails,
                                "CentralAssistApproved",
                                0
                              )
                            )
                              ? Number(
                                  get(
                                    benProjectDetails,
                                    "CentralAssistApproved",
                                    0
                                  )
                                ).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(get(benProjectDetails,"installment1",0))+Number(get(benProjectDetails,"installment2",0))+Number(get(benProjectDetails,"installment3",0))+Number(get(benProjectDetails,"installment4",0))
                              ? Number(Number(get(benProjectDetails,"installment1",0))+Number(get(benProjectDetails,"installment2",0))+Number(get(benProjectDetails,"installment3",0))+Number(get(benProjectDetails,"installment4",0))).toFixed(2)
                              : "-"}
                          </td>
                          <td>
                            {Number(Number(get(benProjectDetails,"installment1",0))+Number(get(benProjectDetails,"installment2",0))+Number(get(benProjectDetails,"installment3",0))+Number(get(benProjectDetails,"installment4",0))) -
                            Number(Number(get(benProjectDetails,"uc1",0))+Number(get(benProjectDetails,"uc2",0))+Number(get(benProjectDetails,"uc3",0))+Number(get(benProjectDetails,"uc4",0)))
                              ? (Number(Number(get(benProjectDetails,"installment1",0))+Number(get(benProjectDetails,"installment2",0))+Number(get(benProjectDetails,"installment3",0))+Number(get(benProjectDetails,"installment4",0))) -
                              Number(Number(get(benProjectDetails,"uc1",0))+Number(get(benProjectDetails,"uc2",0))+Number(get(benProjectDetails,"uc3",0))+Number(get(benProjectDetails,"uc4",0)))) > 0 ? (Number(Number(get(benProjectDetails,"installment1",0))+Number(get(benProjectDetails,"installment2",0))+Number(get(benProjectDetails,"installment3",0))+Number(get(benProjectDetails,"installment4",0))) -
                              Number(Number(get(benProjectDetails,"uc1",0))+Number(get(benProjectDetails,"uc2",0))+Number(get(benProjectDetails,"uc3",0))+Number(get(benProjectDetails,"uc4",0)))).toFixed(2): '-'
                            : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </TableWrapper>

                  <TableWrapper>
                        <div>
                          {" "}
                          Physical Progress <span>(Nos)</span>
                        </div>
                        <table border="1px" border-colapse={"colapse"}>
                          <thead>
                            <tr>
                              <td>Houses</td>
                              <td>Grounded</td>
                              <td>Completed</td>
                              <td>Occupied</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {get(
                                  benProjectDetails,
                                  "HousesSanctionedEnahncement",
                                  0
                                )+get(
                                  benProjectDetails,
                                  "HousesSanctionedNew",
                                  "-"
                                )
                                  ? get(
                                      benProjectDetails,
                                      "HousesSanctionedEnahncement",
                                      "-"
                                    )+get(
                                      benProjectDetails,
                                      "HousesSanctionedNew",
                                      "-"
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  benProjectDetails,
                                  "totalWorkOrders",
                                  0
                                )
                                  ? get(
                                      benProjectDetails,
                                      "totalWorkOrders",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  benProjectDetails,
                                  "completed",
                                  0
                                )
                                  ? get(
                                      benProjectDetails,
                                      "completed",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  benProjectDetails,
                                  "occupied",
                                  0
                                )
                                  ? get(
                                      benProjectDetails,
                                      "occupied",
                                      0
                                    )
                                  : "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </TableWrapper>

                      <Gallery>
                        {
                          map(sortBy(beneficiariesImages,'ConstructionStage'), (arr,i)=>{
                             console.log('arr------>>',arr)
                              return(
                                <React.Fragment key={i}>
                                <div>
                                  {/* <img src={`${arr.uri}/${arr.photo1}`} alt=''/> */}
                                  {/* <ImgLoader src={`${arr.uri}/${arr.photo1}`} */}
                                  <ImgLoader src={`${arr.photo1}`} className={'photo1'+i} alt="..."/>
                                  <p style={{background:arr.ConstructionStage === 'Completed' ? 'green' : 'orange'}}>{arr.ConstructionStage}</p>
                                </div>
                                <div>
                                  {/* <img src={`${arr.uri}/${arr.photo2}`} alt=''/> */}
                                  {/* <ImgLoader src={`${arr.uri}/${arr.photo2}`} */}
                                  <ImgLoader src={`${arr.photo2}`} className={'photo2'+i} alt="..."/>
                                  <p style={{background:arr.ConstructionStage === 'Completed' ? 'green' : 'orange'}}>{arr.ConstructionStage}</p>
                                </div>
                                </React.Fragment>
                              )
                          })
                        }
                      </Gallery>
          </ProjectView>
        </Modal>:''}


        {!isEmpty(this.state.progress) ?
        <Modal onClickIcon={()=> this.setState({beneficiariesData:{},benProjectDetails:{}, progress:{}})}>
          <ProjectView>
            {/* Note */}
            <Note style={{paddingBottom:15}}><span>Note:</span>Progress of only  EWS housing to be given. Do not input for LIG, MIG and HIG</Note>

            <Formik
            enableReinitialize={true}
            // validationSchema={VisitorFormSchema}
            initialValues={!isEmpty(this.state.progress) ? this.state.progress : {
              completed:0,
               occupied:0,
               ground:0,
               plinth:0,
              lintel:0,
              roof:0
            }}
            onSubmit={async (input, { resetForm, setValues }) => {
              // console.log('input------->>', input)
              // return null

              const totalHouses = Number(get(input,'HousesSanctionedEnahncement')||0)+Number(get(input,'HousesSanctionedNew')||0)
              const entryOfHouses = Number(get(input,'completed')||0)+Number(get(input,'ground')||0)+Number(get(input,'lintel')||0)+Number(get(input,'plinth')||0)+Number(get(input,'roof')||0)

              if (entryOfHouses > totalHouses ) {
                toast("Progress of houses not greater than houses sanctioned", {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
              }

              

                // console.log('update--------->>', data)
                await axios.post(`/visitor/physical-progress/`, input)
                  .then((res) => {
                    toast("Form Updated Successfully ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                    this.setState({progress:{}})
                  })
                  .catch((err) => {
                    toast("Error: Form Not Updated ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  });
              
            }}
          >
            {(formikBag) => {

              // console.log('formikBag----->>>', formikBag.values)
              return (
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    formikBag.validateForm().then((errors) => {
                      const errKeys = Object.keys(errors);
                      // console.log({errors, errKeys})
                      if (errKeys.length > 0) {
                        const errMessage =
                          typeof errors[errKeys[0]] === "string"
                            ? errors[errKeys[0]]
                            : errors[errKeys[0]]["value"];
                        // console.log('errMessage---->>', errMessage)
                        toast(errMessage, {
                          position: toast.POSITION.BOTTOM_CENTER,
                        });
                        return null;
                      } else {
                        return formikBag.handleSubmit();
                      }
                    });
                  }}
                >
                  <InputWrapper >
                    <div>
                      <label>Houses: <strong>{Number(get(formikBag,'values.HousesSanctionedEnahncement')||0)+Number(get(formikBag,'values.HousesSanctionedNew')||0) ? Number(get(formikBag,'values.HousesSanctionedEnahncement')||0)+Number(get(formikBag,'values.HousesSanctionedNew')||0) : '-'}</strong></label>
                    </div>
                    <div>
                    <label>Grounded: <strong>{get(formikBag,'values.totalWorkOrders') ? get(formikBag,'values.totalWorkOrders') : '-'}</strong></label>
                    </div>
                  </InputWrapper>

                  <InputWrapper >
                    <div>
                      <label>Completed</label>
                      <Field
                        name="completed"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                    <div>
                    <label>Occupied</label>
                      <Field
                        name="occupied"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                  </InputWrapper>
                
                  <InputWrapper >
                    <div>
                      <label>Ground Level</label>
                      <Field
                        name="ground"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                    <div>
                    <label>Plinth Level</label>
                      <Field
                        name="plinth"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                  </InputWrapper>
                  <InputWrapper >
                    <div>
                      <label>Lintel Level</label>
                      <Field
                        name="lintel"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                    <div>
                    <label>Roof Level</label>
                      <Field
                        name="roof"
                        render={({ field, form }) => (
                          <Input
                            {...field}
                            type='number'
                          />
                        )}
                      />
                    </div>
                  </InputWrapper>
                  <InputWrapper>
                  <div style={{width:'100%'}}><label>Remarks / Reasons for Non-starter</label></div>
                    <Field
                        name="remarks"
                        render={({ field, form }) => (
                          <TextArea
                            {...field}
                          />
                        )}
                      />
                  </InputWrapper>

  
                  <ButtonWrapper>
                    <Button1 type="submit">Submit</Button1>
                  </ButtonWrapper>
                </form>
              );
            }}
          </Formik>
          
          </ProjectView>
        </Modal>:''}


      </React.Fragment>
    )
  }
}

export { NearestBeneficiaries }